import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

// Months considered "vacation season" in Brazil: Dec, Jan, Jul
const VACATION_MONTHS = [12, 1, 7];

export function SeasonalPrompts() {
  const navigate = useNavigate();
  const [show, setShow]   = useState(false);
  const [tried, setTried] = useState(false);

  useEffect(() => {
    const month = new Date().getMonth() + 1;
    if (!VACATION_MONTHS.includes(month)) return;

    const key = `seasonal_astrocarto_${new Date().toISOString().slice(0, 7)}`;
    if (localStorage.getItem(key)) return;

    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      // Only show if user hasn't tried Astrocartografia
      const { data } = await supabase
        .from('system_usage')
        .select('id')
        .eq('user_id', user.id)
        .eq('system_name', 'astrocartografia')
        .maybeSingle();

      setTried(!!data);
      if (!data) setShow(true);
    })();
  }, []);

  function dismiss() {
    const key = `seasonal_astrocarto_${new Date().toISOString().slice(0, 7)}`;
    localStorage.setItem(key, '1');
    setShow(false);
  }

  if (!show || tried) return null;

  return (
    <div className="border border-[#C9A84C]/20 rounded-sm p-4 bg-gradient-to-r from-[#0D1130] to-[#C9A84C]/5 flex items-start gap-3">
      <span className="text-2xl flex-shrink-0">🗺️</span>
      <div className="flex-1 min-w-0">
        <p className="text-[#F5ECD7]/90 text-sm font-medium mb-1">
          Planejando uma viagem?
        </p>
        <p className="text-[#F5ECD7]/60 text-xs leading-relaxed mb-3">
          A Astrocartografia mostra quais destinos são mais favoráveis para você com base no seu mapa natal, amor, carreira, criatividade e mais.
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => { dismiss(); navigate('/astrocartografia'); }}
            className="px-4 py-2 bg-[#C9A84C] text-[#0D1130] text-xs font-bold uppercase tracking-wider hover:bg-[#C9A84C]/90 transition-colors"
          >
            Descobrir meus destinos
          </button>
          <button
            onClick={dismiss}
            className="px-3 py-2 text-[#F5ECD7]/40 text-xs hover:text-[#F5ECD7]/70 transition-colors"
          >
            Talvez depois
          </button>
        </div>
      </div>
    </div>
  );
}
